export default "__VITE_ASSET__BSJPhRF5__"